/**
 * Debounces a function to be called on the next animation frame.
 *
 * @internal scope: workspace
 */
export function debounceAnimationFrame(fn) {
    let frameId;
    let latestThis;
    let latestArgs;
    const debounced = function (...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        latestThis = this;
        latestArgs = args;
        if (frameId !== undefined) {
            cancelAnimationFrame(frameId);
        }
        frameId = requestAnimationFrame(() => {
            frameId = undefined;
            fn.apply(latestThis, latestArgs);
        });
    };
    const cancel = () => {
        if (frameId !== undefined) {
            cancelAnimationFrame(frameId);
            frameId = undefined;
        }
    };
    const flush = () => {
        if (frameId !== undefined) {
            cancelAnimationFrame(frameId);
            frameId = undefined;
            fn.apply(latestThis, latestArgs);
        }
    };
    return Object.assign(debounced, { cancel, flush });
}
